import * as DropdownMenu from '@radix-ui/react-dropdown-menu'

export default function AppActionMenu({
  triggerLabel = '',
  triggerIcon = triggerLabel ? null : 'more_vert',
  showChevron = true,
  items = [],
  onSelect,
  disabled = false,
  className = '',
  triggerClassName = '',
  menuClassName = '',
  align = 'right',
}) {
  const panelAlign = align === 'left' ? 'start' : 'end'

  return (
    <DropdownMenu.Root modal={false}>
      <div className={`relative ${className}`}>
        <DropdownMenu.Trigger asChild>
          <button
            type="button"
            disabled={disabled}
            className={`inline-flex items-center justify-center gap-2 rounded-full bg-surface-container-highest px-4 py-2 text-sm font-bold text-on-surface transition hover:brightness-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/25 disabled:cursor-not-allowed disabled:opacity-60 ${triggerClassName}`}
          >
            {triggerIcon ? <span className="material-symbols-outlined text-base">{triggerIcon}</span> : null}
            {triggerLabel ? <span>{triggerLabel}</span> : null}
            {showChevron ? (
              <span className="material-symbols-outlined text-base text-on-surface-variant">expand_more</span>
            ) : null}
          </button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content
            align={panelAlign}
            sideOffset={8}
            collisionPadding={12}
            className={`z-[350] min-w-[156px] overflow-hidden rounded-2xl border border-outline-variant/20 bg-surface-container-lowest py-1.5 shadow-[0_14px_32px_rgba(15,23,42,0.2)] backdrop-blur-xl ${menuClassName}`}
          >
            {items
              .filter(Boolean)
              .filter((item) => item.separator || item.label)
              .map((item, index) => {
                if (item.separator) {
                  return (
                    <DropdownMenu.Separator
                      key={`sep-${index}`}
                      className="my-1.5 h-px bg-outline-variant/20"
                    />
                  )
                }
                const isDanger = item.variant === 'danger' || item.danger
                return (
                  <DropdownMenu.Item
                    key={`${item.key || item.label || index}-${index}`}
                    disabled={Boolean(item.disabled)}
                    onSelect={() => {
                      if (item.disabled) return
                      item.onClick?.()
                      onSelect?.(item.key)
                    }}
                    className={`flex cursor-pointer items-center gap-2.5 px-3.5 py-2 text-left outline-none transition hover:bg-surface-container-low focus:bg-surface-container-low data-[disabled]:cursor-not-allowed data-[disabled]:opacity-45 ${
                      isDanger ? 'text-error hover:bg-error-container/20 hover:text-error' : 'text-on-surface'
                    }`}
                  >
                    {item.icon ? (
                      <span
                        className={`material-symbols-outlined text-base ${
                          isDanger ? 'text-error' : (item.iconClassName || 'text-on-surface-variant')
                        }`}
                      >
                        {item.icon}
                      </span>
                    ) : (
                      <span className="material-symbols-outlined text-base text-transparent">check</span>
                    )}
                    <span className="text-sm leading-tight">{item.label}</span>
                  </DropdownMenu.Item>
                )
              })}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </div>
    </DropdownMenu.Root>
  )
}
